import { render, staticRenderFns } from "./F-2__EDMsubscribers.vue?vue&type=template&id=c3b64c8e&"
import script from "./F-2__EDMsubscribers.vue?vue&type=script&lang=js&"
export * from "./F-2__EDMsubscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
